export interface BaselinePassage {
  id: string;
  text: string;
}

export const BASELINE_PASSAGES: BaselinePassage[] = [
  {
    id: 'passage-a',
    text:
      'En kort tur gennem byen giver ofte nye tanker. ' +
      'Mange skriver mails og noter på dansk hver eneste dag. ' +
      'Det kræver øvelse at ramme alle taster uden at kigge ned. ' +
      'Prøv at holde et jævnt tempo, selv når teksten er længere end ventet. ' +
      'Små pauser mellem sætningerne hjælper både hænder og hoved.',
  },
  {
    id: 'passage-b',
    text:
      'Vintermorgen: frost på ruden og cykler ved lygtepælen. ' +
      'Jeg tænker på mødet klokken ni og de åbne spørgsmål der venter. ' +
      'Kollegaen sender en besked — skal vi have kaffe først? ' +
      'Jeg svarer ja, tager jakken og låser døren. ' +
      'På vej ned ad trappen husker jeg en tanke til præsentationen.',
  },
  {
    id: 'passage-c',
    text:
      'Teknologi ændrer hvordan vi arbejder, lærer og mødes. ' +
      'Et godt tastatur og gode vaner sparer tid hver uge. ' +
      'Øvelse gør forskellen, især når fingrene skal finde æ og ø uden at tænke. ' +
      'Målet er ikke perfektion første gang, men tydelig fremgang uge for uge.',
  },
];

export function pickBaselinePassage(seed?: number): BaselinePassage {
  const idx =
    seed !== undefined
      ? Math.abs(seed) % BASELINE_PASSAGES.length
      : Math.floor(Math.random() * BASELINE_PASSAGES.length);
  return BASELINE_PASSAGES[idx]!;
}
